import { Suspense } from "react";
import { Outlet } from "react-router-dom";

// import Footer from "./components/Footer/Footer";
// import GlobalHeader from "./components/Header/Header";
import Loading from "./components/Loading/Loading";

export default function ICALayout() {
  const isLoading = false;

  return (
    <>
      {/* <header>
        <GlobalHeader />
      </header> */}
      {isLoading ? (
        <Loading />
      ) : (
        <Suspense fallback={<Loading />}>
          <Outlet />
        </Suspense>
      )}
      {/* <Footer /> */}
    </>
  );
}
